import React, { useState, useEffect, useContext } from 'react';
import styles from './MatchesComponent.module.css';
import MatchCardPost from './MatchCardPost';
import { MatchContext } from '../../createContext/Match/MatchContext';
import IsAuth from '../../createContext/is-Auth/IsAuthContext';
import addScore from '../images/addScore.png';
import ScoreModal from '../Home/Modals/ScoreModal/ScoreModal';

const MatchesComponent = () => {
  const sportTypes = ['All', 'Football', 'Tennis', 'Cricket', 'Basketball', 'Soccer'];
  const [isScoreModalOpen, setIsScoreModalOpen] = useState(false);
  const [selectedMatchId, setSelectedMatchId] = useState(null);
  const [showDateTimeModal, setShowDateTimeModal] = useState(false);
  const [activeFilters, setActiveFilters] = useState({
    matchType: '1 on 1',
    sportType: 'All',
    status: 'all',
    myMatches: true
  });
  const [locationSearch, setLocationSearch] = useState('');
  const { matches } = useContext(MatchContext);
  const { user } = useContext(IsAuth);
  
  const handleOpenScoreModal = (matchId) => {
    setSelectedMatchId(matchId);
    setIsScoreModalOpen(true);
  };

  const handleCloseScoreModal = () => {
    setIsScoreModalOpen(false);
    setSelectedMatchId(null);
  };

  const filterMatches = (matches) => {
    return matches.filter(match => {
      const matchTypeFilter =
        activeFilters.matchType === '1 on 1' ? !match.isTeamMatch : match.isTeamMatch;

      const sportTypeFilter =
        activeFilters.sportType === 'All' || match.sport.name.toLowerCase() === activeFilters.sportType.toLowerCase();

      const locationFilter =
        locationSearch.trim() === '' || match.location.toLowerCase().includes(locationSearch.toLowerCase());

      let statusFilter = 
        activeFilters.status === 'all' || match.status === activeFilters.status;
      
      if (activeFilters.status === 'completed' && canAddScore(match)) statusFilter = true;
      if (activeFilters.status === 'scheduled' && canAddScore(match)) statusFilter = false

      const myMatchesFilter = !activeFilters.myMatches || 
        (match.players && match.players.some(player => player._id === user?._id));

      return matchTypeFilter && sportTypeFilter && locationFilter && statusFilter && myMatchesFilter;
    });
  };

  const handleFilterChange = (type, value) => {
    setActiveFilters(prev => ({
      ...prev,
      [type]: value,
    }));
  };

  const isMatchOwner = (match) => {
    return match.players && match.players.some(player => player._id === user?._id);
  };

  const canAddScore = (match) => {
    const matchDate = new Date(match.date);
    const now = new Date();
    return isMatchOwner(match) && matchDate < now && match.status === 'scheduled';
  };

  const filteredMatches = filterMatches(matches);

  return (
    <>
        <section className={styles.matchesSection}>
          <div className={styles.matchesContainer}>
            <div className={styles.headerSection}>
              <h2 className={styles.matchesTitle}>Matches</h2>
              <div className={styles.myMatchesToggle}>
                <span className={styles.toggleLabel}>My Matches</span>
                <label className={styles.switch}>
                  <input
                    type="checkbox"
                    checked={activeFilters.myMatches}
                    onChange={() => handleFilterChange('myMatches', !activeFilters.myMatches)}
                  />
                  <span className={styles.slider}></span>
                </label>
              </div>
            </div>
            <div className={styles.filterContainer}>
              <div className={styles.fixedFilters}>
                <div className={styles.locationFilter}>
                  <img 
                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/17bcbe26b1f122f770e5508255920dbf8c86e4bbc9d969ec144cdf0a9f79a293?placeholderIfAbsent=true&apiKey=b883bcf213724f38a6f53982628f709c" 
                    alt="" 
                    className={styles.locationIcon} 
                  />
                  <input
                    type="text"
                    placeholder="Search by Location"
                    value={locationSearch}
                    onChange={(e) => setLocationSearch(e.target.value)}
                    className={styles.locationText}
                  />
                </div>
                <div className={styles.typeFilters}>
                  <button 
                    className={`${styles.filterButton} ${activeFilters.matchType === '1 on 1' ? styles.activeFilter : ''}`}
                    onClick={() => handleFilterChange('matchType', '1 on 1')}
                  >
                    1 on 1
                  </button>
                  <button 
                    className={`${styles.filterButton} ${activeFilters.matchType === 'Team' ? styles.activeFilter : ''}`}
                    onClick={() => handleFilterChange('matchType', 'Team')}
                  >
                    Team
                  </button>
                </div>
              </div>
              <div className={styles.sportTypeFilterWrapper}>
                <div className={styles.sportTypeFilter}>
                  {sportTypes.map((sport, index) => (
                    <button 
                      key={index} 
                      className={`${styles.filterButton} ${activeFilters.sportType === sport ? styles.activeFilter : ''}`}
                      onClick={() => handleFilterChange('sportType', sport)}
                    >
                      {sport}
                    </button>
                  ))}
                </div>
              </div>
              <div className={styles.statusFilters}>
                <button
                  className={`${styles.filterButton} ${activeFilters.status === 'all' ? styles.activeFilter : ''}`}
                  onClick={() => handleFilterChange('status', 'all')}
                >
                  All Matches
                </button>
                <button
                  className={`${styles.filterButton} ${activeFilters.status === 'scheduled' ? styles.activeFilter : ''}`}
                  onClick={() => handleFilterChange('status', 'scheduled')}
                >
                  Upcoming
                </button>
                <button
                  className={`${styles.filterButton} ${activeFilters.status === 'completed' ? styles.activeFilter : ''}`}
                  onClick={() => handleFilterChange('status', 'completed')}
                >
                  Completed
                </button>
              </div>
            </div>
            <div className={styles.matchCardContainer}>
            {filteredMatches.length === 0 ? (
              <div>No matches found</div>
            ) : (
              filteredMatches.map(match => (
                <div key={match._id} className={styles.matchWrapper}>
                  {canAddScore(match) && (
                    <button
                      type="button"
                      className={styles.addScoreButton}
                      onClick={() => handleOpenScoreModal(match._id)}
                    >
                      <img src={addScore} alt="" className={styles.actionIcon} />
                      <span>Add Score</span>
                    </button>
                  )}
                  <MatchCardPost 
                    matchData={match}
                    canAddScore = {canAddScore(match)}
                  />
                </div>
              ))
            )}
          </div>
          
          {isScoreModalOpen && (
            <ScoreModal
              isOpen={isScoreModalOpen}
              onClose={handleCloseScoreModal}
              handleShowDateModal={() => setShowDateTimeModal(!showDateTimeModal)}
              showDateTimeModal={showDateTimeModal}
              preInput={selectedMatchId}
            />
          )}
        </div>
        </section>
    </>
  );
};

export default MatchesComponent;